import { render, staticRenderFns } from "./InventoryManagement.vue?vue&type=template&id=60fe8376&"
import script from "./InventoryManagement.vue?vue&type=script&lang=js&"
export * from "./InventoryManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports